import { render } from "./TableCellCenter.vue?vue&type=template&id=61567278"
import script from "./TableCellCenter.vue?vue&type=script&lang=js"
export * from "./TableCellCenter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__